import { ReactElement } from 'react';

import Link from 'next-translate-routes/link';
import Slider, { Settings } from 'react-slick';

import { useMediaQuery } from '@hooks/useMediaQuery';
import { smallScreen } from '@styles/constants';

import { linkResolver } from '@prismic/prismic-config';

import { IProps } from './types';
import * as S from './styles';

const sliderSettings: Settings = {
  arrows: false,
  autoplay: false,
  dots: false,
  infinite: true,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 1000,
};

export function SliceIconBanner({
  slice: { primary, fields },
}: IProps): ReactElement {
  const [isSmallScreen] = useMediaQuery(`(max-width: ${smallScreen}px)`);

  return (
    <S.Wrapper className="slice-item slice-icon-banner">
      {primary?.title && (
        <S.Title className="slice-icon-banner__title">{primary?.title}</S.Title>
      )}
      {isSmallScreen ? (
        <Slider {...sliderSettings}>
          {fields?.map((item, i) => {
            const { title, img } = item;
            return (
              <S.Item
                as="div"
                key={`slice-icon-banner-${i}`}
                className="slice-icon-banner__list-item"
              >
                <img src={img?.url || ''} alt="icon" />
                <span
                  dangerouslySetInnerHTML={{
                    __html: title?.replace(/\n/, '<br/>') || '',
                  }}
                />
              </S.Item>
            );
          })}
        </Slider>
      ) : (
        <>
          {Boolean(fields.length) && (
            <S.List className="slice-icon-banner__list">
              {fields?.map((item, i) => {
                const { title, img } = item;
                const _link: Linkable = item?.link as unknown as Linkable;

                if (item.link) {
                  return (
                    <Link
                      href={linkResolver(_link)}
                      key={`slice-icon-banner-${i}`}
                    >
                      <S.Item as="a">
                        <img src={img?.url || ''} alt="icon" />
                        <span
                          dangerouslySetInnerHTML={{
                            __html: title?.replace(/\n/, '<br/>') || '',
                          }}
                        />
                      </S.Item>
                    </Link>
                  );
                }

                return (
                  <S.Item
                    as="li"
                    key={`slice-icon-banner-${i}`}
                    className="slice-icon-banner__list-item"
                  >
                    <img src={img?.url || ''} alt="icon" />
                    <span
                      dangerouslySetInnerHTML={{
                        __html: title?.replace(/\n/, '<br/>') || '',
                      }}
                    />
                  </S.Item>
                );
              })}
            </S.List>
          )}
        </>
      )}
    </S.Wrapper>
  );
}

SliceIconBanner.componentName = 'iconbanner';
